"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("../config"));
const internal_api_util_1 = __importDefault(require("./internal-api-util"));
const { services: { gatekeeper: { url: GATEKEEPER_URL } } } = config_1.default;
const validateSession = (sessionId) => () => __awaiter(void 0, void 0, void 0, function* () {
    return internal_api_util_1.default.get(`${GATEKEEPER_URL}/sessions/${sessionId}`);
});
const authLwt = body => () => __awaiter(void 0, void 0, void 0, function* () {
    return internal_api_util_1.default.post(`${GATEKEEPER_URL}/auth/lwt`, { body });
});
exports.default = { validateSession, authLwt };
